module.exports = __webpack_public_path__ + "img/noData.7a60a942.png";